module.exports = __webpack_public_path__ + "img/樺島宏樹.3349d342.jpg";